var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DialogCard',{attrs:{"title":_vm.title,"actions":_vm.actions}},[_c('v-color-picker',{attrs:{"flat":""},model:{value:(_vm.privColor),callback:function ($$v) {_vm.privColor=$$v},expression:"privColor"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }